import { NgModule } from "@angular/core";
import { S25OfficeHoursSliderComponent } from "./s25.office.hours.slider.component";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [CommonModule, NgxSliderModule],
    exports: [S25OfficeHoursSliderComponent],
    declarations: [S25OfficeHoursSliderComponent],
    providers: [S25OfficeHoursSliderComponent],
})
export class S25OfficeHoursSliderModule {}
